import FixedDeposits from '@components/Products/FixedDeposits';
import {
    fdCarouselContent,
    fdDefaultCompareContent,
    fdDefaultInterestRate,
    isFDFeatureEnabled,
} from '@components/Products/FixedDeposits/utils/helper';
import StructuredData from '@components/StructuredData';
import { productStructuredData } from '@helpers/constants';
import { configurationEntityTypes } from '@helpers/enums/configuration-enums';
import { triggerOnPage } from '@helpers/ga-events-name-enum';
import { HeadTagData } from '@helpers/headTagData';
import { triggerCustomGaEvent } from '@helpers/miscelleanous';
import { isValidResponseEntity } from '@helpers/utils';
import { getOpenConfigurations } from '@services/configuration.service';
import NextHeadTag from '@ui/molecules/NextHeadTag';
import { useEffect } from 'react';
import { logEvent, moengageEventConstants } from '@services/moengage';

const FixedDepositsPage = ({ fdDetails }) => {
    const headTagProps = HeadTagData?.[`/products/fixed-deposit`] || {};
    useEffect(() => {
        triggerCustomGaEvent(triggerOnPage.VIEWED_FD_PAGE);
        logEvent({ eventName: moengageEventConstants.VIEWED_FD_PAGE });
    }, []);

    return (
        <div>
            <NextHeadTag {...headTagProps} />
            <StructuredData data={productStructuredData} />
            <FixedDeposits
                fixedDepositBanks={fdDetails?.carouselContent}
                fdCompareContent={fdDetails?.fdCompareContent}
                fdInterestRate={fdDetails?.fdInterestRate}
            />
        </div>
    );
};

export const getStaticProps = async (ctx) => {
    const defaultFixedDepositBanks = {
        fdInterestRate: fdDefaultInterestRate,
        carouselContent: fdCarouselContent.cards,
        fdCompareContent: fdDefaultCompareContent,
    };
    try {
        if (!isFDFeatureEnabled) {
            return {
                notFound: true,
            };
        }
        const response = await getOpenConfigurations(
            configurationEntityTypes.FIXED_DEPOSIT_CONTENT,
            ctx
        );

        if (!isValidResponseEntity(response)) {
            return {
                props: {
                    fdDetails: defaultFixedDepositBanks,
                },
                revalidate: 86400,
            };
        }

        const fdDetails = response.entity?.[0]?.value
            ? JSON.parse(response.entity[0].value)
            : defaultFixedDepositBanks;
        return {
            props: { fdDetails },
            revalidate: 86400,
        };
    } catch (error) {
        return {
            props: { fdDetails: defaultFixedDepositBanks },
            revalidate: 86400,
        };
    }
};

export default FixedDepositsPage;
